import React, { useCallback, ReactElement } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const ErrorLayout: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    component,
    componentProps,
    children,
  } = props;

  const errorFallbackRender: FallbackRenderFunction = useCallback((
    fallbackProps: FallbackProps,
  ): FallbackComponent => {
    const {
      error,
      resetErrorBoundary: onTryAgainClick,
    } = fallbackProps;

    const InnerComponent: ReactComponent = component;

    return (
      <InnerComponent
        error={error}
        onTryAgainClick={onTryAgainClick}
        {...componentProps}
      />
    );
  }, [component, componentProps]);

  return (
    <ErrorBoundary fallbackRender={errorFallbackRender}>
      {children}
    </ErrorBoundary>
  );
});

export default ErrorLayout;
